/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["section[_ngcontent-%COMP%]{display:-webkit-box;display:flex;flex-wrap:wrap;width:100%}section[_ngcontent-%COMP%]   app-single-tag[_ngcontent-%COMP%], section[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{width:50%}.cms-button-text-primary[_ngcontent-%COMP%]{border:none;align:center;text-align:center;padding-top:10px;padding-bottom:10px;width:95%;cursor:pointer;height:3.5rem}"];
export { styles as styles };
